import React from 'react'
import posthog from 'posthog-js'

// trackedTitle - format [component][step] action
const TrackableExternalLink = ({ href, children, trackedGroup, trackedTitle, onClick, ...props }) => {

const handleClick = event => {
    // Track the click event in PostHog
    posthog.capture(trackedTitle, { path: href, group: trackedGroup })

    if (onClick) {
      onClick(event)
    }
  }

  return (
    <a href={href} target="_blank" onClick={handleClick} {...props}>
      {children}
    </a>
  )
}

export default TrackableExternalLink